import client, { PaginatedResponse } from '@/utils/client'
import urls from '@/utils/urls'

var defaultState = {}

export const mutations = {
}

export const getters = {
}

export const actions = {
  searchAlbums (ctx, filter) {
    return client.get(urls.search.albums(), {params: filter}).then(r => new PaginatedResponse(r.data))
  },
  searchArtists (ctx, filter) {
    return client.get(urls.search.artists(), {params: filter}).then(r => new PaginatedResponse(r.data))
  },
  searchLiveEvents (ctx, filter) {
    return client.get(urls.search.live(), {params: filter}).then(r => new PaginatedResponse(r.data))
  },
  searchPlaylists (ctx, filter) {
    return client.get(urls.search.playlists(), {params: filter}).then(r => new PaginatedResponse(r.data))
  },
  searchSongs (ctx, filter) {
    return client.get(urls.search.songs(), {params: filter}).then(r => new PaginatedResponse(r.data))
  },
  getRecommendations (ctx, filter) {
    return client.get(urls.search.recommended()).then(r => r.data)
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js